export default (args: {updateFetchedData: Function, fetchedData: any}) => (newColumns: any) => {
  args.updateFetchedData()({
    target: {
      type: "custom", name: "missionProfile", value: {
        ...args.fetchedData.missionProfile,
        customKanbanView: newColumns,
      }
    }
  });
}